import React, { useCallback, useContext, useEffect, useState } from 'react';
import { FirebaseContext } from '../../../context/firebase';
import * as PROJECT_CODE from '../../../constants/projectCode';
import dayjs from 'dayjs';

import EmailIcon from '@material-ui/icons/Email';
import CallOutlinedIcon from '@material-ui/icons/CallOutlined';
import DateRangeOutlinedIcon from '@material-ui/icons/DateRangeOutlined';
import ScheduleIcon from '@material-ui/icons/Schedule';
import CheckCircleOutlineIcon from '@material-ui/icons/CheckCircleOutline';
import CancelIcon from '@material-ui/icons/Cancel';
import EditIcon from '@material-ui/icons/Edit';
import clsx from 'clsx';
import './AppointmentList.css';
import { render } from '@testing-library/react';
import { useHistory } from 'react-router';
import { CircularProgress, makeStyles, Tooltip } from '@material-ui/core';
import Modal from '../../layout/modal/Modal';
import DatePicker from 'react-datepicker';

const AppointmentsList = () => {
	const { firebase } = useContext(FirebaseContext);
	const history = useHistory();
	const [active, setActive] = useState('upcoming');
	const [alert, setAlert] = useState('');
	const [loading, setLoading] = useState(false);
	const [showEditModal, setShowEditModal] = useState(false);
	const [upcomingDb, setUpcomingDb] = useState([]);
	const [pastDb, setPastDb] = useState([]);
	const [controlBtns, setControlBtns] = useState([]);
	const [editInfo, setEditInfo] = useState();
	const [startDate, setStartDate] = useState();

	useEffect(() => {
		var currentTime = new Date();

		//current time test log
		console.log('This is the current time: ' + currentTime);

		firebase.auth().onAuthStateChanged(function (user) {
			function ReturnScheduledAppointment(
				newKey,
				newTime,
				newEmail,
				newName,
				newNumber,
				shortCode
			) {
				console.log('ReturnScheduledAppointment ' + shortCode);
				var newAppointment = {
					appointmentId: newKey,
					appointmentTime: newTime,
					appointmentMainEmail: newEmail,
					appointmentMainName: newName,
					appointmentMainNumber: newNumber,
					appointmentShortCode: shortCode,
				};

				return newAppointment;
			}
			if (user) {
				var currentUserId = firebase.auth().currentUser.uid;
				var appointmentsRef = firebase
					.database()
					.ref('/client_appointments/' + PROJECT_CODE.projectCode);
				appointmentsRef
					.orderByChild('createrID')
					.equalTo(currentUserId)
					.on('value', (snapshot) => {
						var upcomingAppointments = [];
						var pastAppointments = [];
						snapshot.forEach((element) => {
							var elementTime = element.val().timeOfAppointment;
							let currentTimeDate = Date.now();
							var time30MinAgo = currentTimeDate - 1800000;

							var showClientUser = true;

							//null check
							if (
								element.val().createUser != null &&
								element.val().createUser !== undefined
							) {
								showClientUser = element.val().createUser;
							}

							if (elementTime > time30MinAgo && showClientUser === true) {
								var snapUser = element.child('users');
								var allChildren = [];
								snapUser.forEach((child) => {
									var childUser = {
										childEmail: child.val().email,
										childName: child.val().fullName,
										childNumber: child.val().phoneNumber,
									};
									allChildren.push(childUser);
								});

								console.log('All children: ' + JSON.stringify(allChildren));
								var newAppointment = ReturnScheduledAppointment(
									element.key,
									elementTime,
									allChildren[0].childEmail,
									allChildren[0].childName,
									allChildren[0].childNumber,
									element.val().shortCode
								);

								upcomingAppointments.push(newAppointment);
							} else {
								var showClientUser = true;

								//null check
								if (
									element.val().createUser != null &&
									element.val().createUser !== undefined
								) {
									showClientUser = element.val().createUser;
								}

								if (showClientUser === true) {
									var snapUser = element.child('users');
									var allChildren = [];

									snapUser.forEach((child) => {
										var childUser = {
											childEmail: child.val().email,
											childName: child.val().fullName,
											childNumber: child.val().phoneNumber,
										};
										allChildren.push(childUser);
									});

									if (allChildren.length > 0) {
										var newAppointment = ReturnScheduledAppointment(
											element.key,
											elementTime,
											allChildren[0].childEmail,
											allChildren[0].childName,
											allChildren[0].childNumber,
											element.val().shortCode
										);
										pastAppointments.push(newAppointment);
										setPastDb([pastAppointments]);
									}
								}
								// console.log(
								// 	'FUTURE APPOINTMENT FOUND ' +
								// 		element.key +
								// 		' ' +
								// 		newAppointment.appointmentTime +
								// 		' ' +
								// 		newAppointment.appointmentMainEmail +
								// 		' ' +
								// 		newAppointment.appointmentMainName +
								// 		' ' +
								// 		newAppointment.appointmentMainNumber
								// );
								//now we create the button
							}
						});
						// console.log(
						// 	'Upcoming appointments: ' + JSON.stringify(upcomingAppointments)
						// );
						// console.log(
						// 	'Past appointments: ' + JSON.stringify(pastAppointments)
						// );
						upcomingAppointments.sort(function (a, b) {
							return a.appointmentTime - b.appointmentTime;
						});
						pastAppointments.sort(function (a, b) {
							return a.appointmentTime - b.appointmentTime;
						});
						// console.log(upcomingAppointments);
						// return upcomingAppointments;
						setUpcomingDb([upcomingAppointments]);
					});
			}
		});
	}, []);

	const closeModalHandler = () => {
		setShowEditModal(false);
		setStartDate();
		setEditInfo();
	};

	const handleEditAppt = () => {
		//handle edit goes here
		// console.log('handleEdit: ' + editInfo?.appointmentId);
		var apptRef = firebase
			.database()
			.ref('/client_appointments/' + PROJECT_CODE.projectCode);

		var apptRefChild = apptRef.child(editInfo?.appointmentId);

		// update with the new date
		apptRefChild.update({
			timeOfAppointment: startDate ? new Date(startDate).getTime() : editInfo?.appointmentTime,
		});

		closeModalHandler();
		setAlert('Edit Successfully');
		setTimeout(() => setAlert(''), 3000);
	};

	const useStyles = makeStyles((theme) => ({
		datePicker: {
			outline: 'none',
			borderTop: 'none !important',
			borderLeft: 'none !important',
			borderRight: 'none !important',
			borderBottom: '1px solid #949494 !important',
			borderRadius: '0 !important',
			width: '100% !important',
			textIndent: '0'
		},
		appointmentField: {
			marginTop: '15px',
			color: '#777777',
		},
		textfield: {
			width: '100%',
		},
	}));

	const styles = useStyles();

	const handleVideoCall = (e) => {
		setLoading(true);
		let currentTimeDate = Date.now();
		var timeIn5Min = currentTimeDate + 300000;
		var time30MinAgo = currentTimeDate - 1800000;

		console.log(
			e.target.dataset.name +
				' ON JOIN MEETING CLICK ' +
				e.target.dataset.shortcode
		);

		var appEmail = e.target.dataset.email;
		var appName = e.target.dataset.name;
		var appCode = e.target.dataset.appcode;
		var appTime = e.target.dataset.apptime;
		var appNumber = e.target.dataset.appnumber;
		var thisShortCode = e.target.dataset.shortcode;
		var currentUserId = firebase.auth().currentUser.uid;
		var currentUserType;

		if (appCode !== 'undefined' && timeIn5Min >= appTime) {
			firebase
				.database()
				.ref('/users/' + currentUserId + '/userType')
				.on('value', function (snapshot) {
					currentUserType = snapshot.val();
				});

			var detailsForCall = {
				thisEmail: appEmail,
				thisName: appName,
				thisAppointmentCode: appCode,
				thisAppointmentTime: appTime,
				thisUserType: currentUserType,
				thisPhone: appNumber,
				thisUID: currentUserId,
				shortCode: thisShortCode,
			};

			console.log(
				'This is the details for appointment List to send videocall: ' +
					JSON.stringify(detailsForCall)
			);

			history.push({
				pathname: '/videocall',
				state: {
					detail: detailsForCall,
				},
			});
			setLoading(false);
		} else {
			if (appCode === 'undefined') {
				setAlert('No meetings registered to your account.');
				setTimeout(() => setAlert(''), 3000);
			} else if (timeIn5Min <= appTime) {
				setAlert(
					'Appointment not ready, the earliest you can join is 5 minutes before.'
				);
				setTimeout(() => setAlert(''), 3000);
			}
			setLoading(false);
		}
	};

	const handleCancel = useCallback(async (e) => {
		var allKeysToDelete = [];
		var allClientsToSendEmails = [];
		var deleteKey = e.target.dataset.appcode;
		var appEmail = e.target.dataset.email;
		var appTime = e.target.dataset.apptime;
		var appName = e.target.dataset.name;

		console.log('delete key: ' + deleteKey);

		try {
			await await firebase
				.database()
				.ref('/client_emails/' + PROJECT_CODE.projectCode)
				.orderByChild('appointmentID')
				.equalTo(deleteKey)
				.on('value', (snapshot) => {
					firebase
						.database()
						.ref('/client_emails/' + PROJECT_CODE.projectCode)
						.orderByChild('appointmentID')
						.equalTo(deleteKey)
						.off();
					console.log('COUNTING');
					snapshot.forEach((element) => {
						var elementKey = element.key;
						var emailDelete = element.val().email;

						allKeysToDelete.push(elementKey);
						allClientsToSendEmails.push(emailDelete);
					});

					console.log('allKeysToDelete: ' + allKeysToDelete);

					allKeysToDelete.forEach((key) => {
						console.log('KEY TO DELETE ' + key);

						var newDeleteRef = firebase
							.database()
							.ref('/client_emails/' + PROJECT_CODE.projectCode)
							.child(key);
						newDeleteRef.remove();
					});

					allClientsToSendEmails.forEach((emailKey) => {
						console.log('EMAIL TO DELETE ' + emailKey);

						var newDeleteRef = firebase
							.database()
							.ref('/client_delete_emails/' + PROJECT_CODE.projectCode)
							.push();

						newDeleteRef.set({
							email: emailKey,
							adminUser: appEmail,
							timeOfAppointment: appTime,
						});
					});

					var toDelete;
					var counter = 0;

					upcomingDb.forEach((element) => {
						console.log(
							'ALL FUTURE APPOINTMENTS KEY ' +
								element.appointmentId +
								' at index ' +
								deleteKey
						);

						if (element.appointmentId === deleteKey) {
							toDelete = counter;
							console.log('DELETING KEY ' + deleteKey + ' at index ' + counter);
						}
						counter++;
					});

					upcomingDb.splice(toDelete, 1);
					upcomingDb.sort(function (a, b) {
						return a.appointmentTime - b.appointmentTime;
					});
				});

			var newDeleteRef = firebase
				.database()
				.ref('/client_appointments/' + PROJECT_CODE.projectCode)
				.child(deleteKey);

			newDeleteRef.remove();
			setAlert(`Appointment with ${appName} has been cancelled`);
			setTimeout(() => setAlert(''), 4000);
		} catch (error) {
			console.log(error);
		}
	});

	return (
		<>
			{showEditModal === true && (
				<div className='back-drop' onClick={closeModalHandler}></div>
			)}
			{showEditModal === true && (
				<Modal
					show={showEditModal}
					close={closeModalHandler}
					title='Edit Appointment'
					buttonName='Save Edit'
					button={handleEditAppt}
				>
					<div className='form-group'>
						<label
							className={clsx(
								styles.field,
								styles.label,
								styles.appointmentField
							)}
						>
							Appointment Date and Time
						</label>
						<DatePicker
							selected={startDate ? startDate : editInfo?.appointmentTime}
							onChange={(date) => {
								setStartDate(date);
							}}
							minDate={Date.now()}
							showTimeSelect
							timeFormat='HH:mm'
							timeIntervals={15}
							timeCaption='time'
							dateFormat='MMMM d, yyyy h:mm aa'
							className={clsx(styles.field, styles.datePicker)}
						/>
					</div>
				</Modal>
			)}
			<div className='home-card'>
				{loading && (
					<div className='loading_layout_add_people'>
						<CircularProgress
							style={{ position: 'absolute', left: '50%', top: '15%' }}
						/>
					</div>
				)}
				{alert && <p className='form-alert'>{alert}</p>}
				<h2>APPOINTMENTS</h2>
				<div className='appointment-controls'>
					<button
						className={active == 'upcoming' ? 'btn active' : 'btn'}
						onClick={() => setActive('upcoming')}
					>
						Upcoming
					</button>
					<button
						className={active == 'past' ? 'btn active' : 'btn'}
						onClick={() => setActive('past')}
					>
						Past
					</button>
				</div>
				<div className={active === 'upcoming' && 'hideElement'}>
					<div className='appointment-list'>
						{pastDb[0] === undefined || pastDb === ''
							? console.log('none')
							: pastDb[0].map((appointment) => {
									var dateObj = new Date(appointment.appointmentTime);
									var currentTime = Date.now() - 1800000;
									return (
										<div
											key={appointment.appointmentId}
											className='appointmentCard'
										>
											<div className='client-appointment-name'>
												{appointment.appointmentMainName}
											</div>
											<div className='client-appointment-email'>
												<EmailIcon />
												{appointment.appointmentMainEmail}
											</div>
											<div className='client-appointment-phone'>
												<CallOutlinedIcon />
												{appointment.appointmentMainNumber}
											</div>
											<div className='client-appointment-date'>
												<DateRangeOutlinedIcon />
												{dayjs(dateObj).format('DD/MM/YYYY')} &nbsp; &nbsp;
												&nbsp; &nbsp; &nbsp; <ScheduleIcon />
												{dayjs(dateObj).format('h:mmA')}
											</div>
										</div>
									);
							  })}
					</div>
				</div>
				<div className={active === 'past' && 'hideElement'}>
					<div className='appointment-list'>
						{upcomingDb[0] === undefined || upcomingDb === ''
							? console.log('none')
							: upcomingDb[0].map((appointment) => {
									var dateObj = new Date(appointment.appointmentTime);
									var currentTime = Date.now() - 1800000;
									if (appointment.appointmentTime > currentTime) {
										console.log(
											appointment.appointmentId +
												' Populate meetings short codes: ' +
												appointment.appointmentShortCode
										);
										return (
											<div
												key={appointment.appointmentId}
												className='appointmentCard'
												id={appointment.appointmentId}
											>
												<div
													className='edit_appt_btn'
													onClick={(e) => {
														setShowEditModal(true);
														setEditInfo({
															appointmentId: appointment.appointmentId,
															appointmentTime: appointment.appointmentTime,
														});
													}}
												>
													<Tooltip title='Edit'>
														<EditIcon />
													</Tooltip>
												</div>
												<div className='client-appointment-name'>
													{appointment.appointmentMainName}
												</div>
												<div className='client-appointment-email'>
													<EmailIcon />
													{appointment.appointmentMainEmail}
												</div>
												<div className='client-appointment-phone'>
													<CallOutlinedIcon />
													{appointment.appointmentMainNumber}
												</div>
												<div className='client-appointment-date'>
													<DateRangeOutlinedIcon />
													{dayjs(dateObj).format('DD/MM/YYYY')} &nbsp; &nbsp;
													&nbsp; &nbsp; &nbsp; <ScheduleIcon />
													{dayjs(dateObj).format('h:mmA')}
												</div>
												<div className='appointment-confirmation-controls'>
													<button
														className='btn btnJoin'
														data-email={appointment.appointmentMainEmail}
														data-name={appointment.appointmentMainName}
														data-appcode={appointment.appointmentId}
														data-apptime={appointment.appointmentTime}
														data-appnumber={appointment.appointmentMainNumber}
														data-shortcode={appointment.appointmentShortCode}
														onClick={handleVideoCall}
													>
														<CheckCircleOutlineIcon />
														Join
													</button>
													<button
														className='btn btnCancel'
														onClick={handleCancel}
														data-appcode={appointment.appointmentId}
														data-apptime={appointment.appointmentTime}
														data-email={appointment.appointmentMainEmail}
														data-name={appointment.appointmentMainName}
														data-shortcode={appointment.appointmentShortCode}
													>
														<CancelIcon />
														Cancel
													</button>
												</div>
											</div>
										);
									} else if (pastDb[0] !== undefined || pastDb !== '') {
										return (
											<div
												key={appointment.appointmentId}
												className='appointmentCard'
											>
												<div className='client-appointment-name'>
													{appointment.appointmentMainName}
												</div>
												<div className='client-appointment-email'>
													<EmailIcon />
													{appointment.appointmentMainEmail}
												</div>
												<div className='client-appointment-phone'>
													<CallOutlinedIcon />
													{appointment.appointmentMainNumber}
												</div>
												<div className='client-appointment-date'>
													<DateRangeOutlinedIcon />
													{dayjs(dateObj).format('DD/MM/YYYY')} &nbsp; &nbsp;
													&nbsp; &nbsp; &nbsp; <ScheduleIcon />
													{dayjs(dateObj).format('h:mmA')}
												</div>
											</div>
										);
									}
							  })}
					</div>
				</div>
			</div>
		</>
	);
};

export default AppointmentsList;
